import { render, staticRenderFns } from "./Periods.vue?vue&type=template&id=f6f1dcf6&"
import script from "./Periods.vue?vue&type=script&lang=js&"
export * from "./Periods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports